const faqs = [
  {
    question: "What can I do with MekPay?",
    answer: "You can fund your wallet, pay bills, move money, request bank withdrawals, and manage supported crypto activity from one account.",
  },
  {
    question: "How are withdrawals handled?",
    answer: "Every withdrawal request gets a unique reference and status updates, so you can track it from request to completion.",
  },
  {
    question: "Is KYC required?",
    answer: "KYC is part of the compliance flow and may be required for higher-risk actions, larger limits, and certain account operations.",
  },
  {
    question: "Which markets is MekPay built for?",
    answer: "MekPay is designed for African users and businesses that need local currency movement alongside digital asset access and wallet-based financial operations.",
  },
  {
    question: "How do I get support?",
    answer: "Use our contact page for account and transaction support. Our team reviews requests and responds as quickly as possible.",
  },
];

export default function FAQPage() {
  return (
    <section className="bg-slate-50 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-6">
        <div className="mb-12 max-w-3xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.25em] text-primary">
            FAQs
          </p>
          <h1 className="text-4xl font-bold text-slate-900 md:text-5xl">
            Answers to common questions.
          </h1>
          <p className="mt-4 text-lg leading-8 text-slate-600">
            Everything you need to know about using MekPay safely and confidently.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((item) => (
            <article key={item.question} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
              <h2 className="text-xl font-semibold text-slate-900">{item.question}</h2>
              <p className="mt-3 text-base leading-7 text-slate-600">{item.answer}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}